<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png">
          <span>志愿者管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for='(item,index) in infoList' :key="index" @click="handleClick(item.uid)">
        <a>
          <img :src="item.img">
          <h5 style="font-size:16px;">{{item.title}}</h5>
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name:"VolunteerManage",  
  data(){
    return {
      volunteerManage: {
        volunteerManage: "居家服务管理",
        title_1: "服务人员列表",
        title_2: "服务列表",
        title_3: "服务订单",
        title_4: "礼品列表",
        title_5: "礼品兑换",
        text_1: "服务人员的基本信息展示",
        text_2: "服务人员服务的信息的展示",
        text_3: "服务人员街道的服务订单",
        text_4: "礼品信息的展示",
        text_5: "服务人员可用兑换的礼品"
      },//引入 lang 里面的字符串资源
      infoList:[],//数据源
    }
  },
  methods:{
    //点击每个
    handleClick(uid){
      console.log(uid);
      switch(uid){
        case 1:
          bus.$emit('homePage',{type:'jump',path:'/volunteerlist',title:this.volunteerManage.title_1});
          break;
        case 2:
          bus.$emit('homePage',{type:'jump',path:'/volunteerservicelist',title:this.volunteerManage.title_2});
          break;
        case 3:
          bus.$emit('homePage',{type:'jump',path:'/inspectOrderlist',title:this.volunteerManage.title_3});
          break;
        case 4:
          bus.$emit('homePage',{type:'jump',path:'/volunteergiftslist',title:this.volunteerManage.title_4});
          break;
        case 5:
          bus.$emit('homePage',{type:'jump',path:'/volunteergiftsRecord',title:this.volunteerManage.title_5});
          break;          
      }
    },

    /**
     * 获取菜单栏的数据列表
    */
    getPageData() {
      this.infoList = [
        {
          url:"/volunteerlist",
          img:require("@/assets/beadhouse/volunteerlist.png"),
          title:this.volunteerManage.title_1,
          text:this.volunteerManage.text_1,
          uid:1
        },
        {
          url:"/volunteerservicelist",
          img:require("@/assets/beadhouse/volunteerservicelist.png"),
          title:this.volunteerManage.title_2,
          text:this.volunteerManage.text_2,
          uid:2
        },
        {
          url:"/inspectOrderlist",
          img:require("@/assets/beadhouse/inspectOrderlist.png"),
          title:this.volunteerManage.title_3,
          text:this.volunteerManage.text_3,
          uid:3
        },
        {
          url:"/volunteergiftslist",
          img:require("@/assets/beadhouse/volunteergiftslist.png"),
          title:this.volunteerManage.title_4,
          text:this.volunteerManage.text_4,
          uid:4
        },
        {
          url:"/volunteergiftsRecord",
          img:require("@/assets/beadhouse/volunteergiftsRecord.png"),
          title:this.volunteerManage.title_5,
          text:this.volunteerManage.text_5,
          uid:5
        }
      ];
    }
  },
  created(){
    this.getPageData(); 
  },
  mounted(){
        
  },
}
</script>
<style lang="scss" scoped>
  .public_bg {
    width: 100%;
    height: 95%;
    padding:0px 0 20px 0;
    background: #FEFEFE;
    .nurse_top {
      border: 1px #F1EFF2 solid;
      background: #F9F7FA;
      position: relative;
        img {
          margin: 14px 12px;
        }
        h5 {
          display: inline-block;
          position: absolute;
          top: 12px;
          font-size: 18px;
        }
    }
    .row_link{
      width: 1259px;
      margin: 34px 35px;
      .item {
        width: 275px;
        height: 99px;
        border: #F0F0F2 1px solid;
        margin-bottom: 34px;
        margin-right: 34px;
        float: left;
        cursor: pointer;
        img {
          float: left;
          margin: 8px 23px 8px 33px;
          margin-right: 16px;
        }
        span {
          color: #666666;
        }
        h5 {
          margin-top: 21px;
          margin-bottom: 8px;
        }
        a:hover {
          color: #333; 
        }
      }
      .item:hover{
        border:1px solid red;
      }
    }
  }
</style>
